import React from 'react';
import {
  Container,
  Grid,
  Typography,
  Box,
} from '@mui/material';
import { Email, Phone, LocationOn } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box sx={{ backgroundColor: '#0B1444', color: '#fff', py: 5, px: 3 }}>
      <Container maxWidth='lg'>
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant='h6' fontWeight='bold'>
              SNOWTECHLABS
            </Typography>
            <Typography variant='body2' sx={{ mt: 2 }}>
              We offer customized & personalized web design & development
              solutions including e-commerce solutions, content management
              system solutions & Graphic design services.
            </Typography>
          </Grid>

          {/* Services */}
          <Grid item xs={12} md={4}>
            <Typography variant='h6' fontWeight='bold'>
              Services
            </Typography>
            {[
              'Website Design & Development',
              'Digital Marketing',
              'Hosting Solutions',
              'Website Security',
              'Graphics & Multimedia',
              'Mobile App Development',
            ].map((service, index) => (
              <Typography key={index} variant='body2' sx={{ mt: 1 }}>
                ▶ {service}
              </Typography>
            ))}
          </Grid>

          {/* Contact Us */}
          <Grid item xs={12} md={4}>
            <Typography variant='h6' fontWeight='bold'>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <Phone sx={{ mr: 1 }} />
              <Typography variant='body2'>+1 6473349760</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <Email sx={{ mr: 1 }} />
              <Typography variant='body2'>info@snowtechlabs.com</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
              <LocationOn sx={{ mr: 1 }} />
              <Typography variant='body2'>
                43 Baby Pointe Trail, Brampton, ON L7A 0W1
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
